import { api } from './client.js'
import { endpoints } from './endpoints.js'

// Platform-admin Operations Dashboard (Phase 1).
//
// GET /api/patients/operations/?days=&customer_type= -> {
//   window_days, generated_at, customer_type_filter,
//   customer_types: [{code,label,color}],
//   sections: {
//     new_patients: {
//       new_today, new_in_window,
//       by_customer_type: [{code,label,color,count}],
//       by_source: {self,staff},
//       rows: [{ id, name, customer_type, customer_type_label, customer_type_color,
//                source, source_detail, organization, registered_by_name,
//                phone, email, created_at }],
//       truncated,
//     },
//     org_activity: [{ organization, customer_type, count }],
//   }
// }
export async function getOperations({ days = 7, customerType = '' } = {}) {
  const params = { days }
  if (customerType) params.customer_type = customerType
  const { data } = await api.get(endpoints.operationsDashboard, { params })
  return data
}
